import { funnelFromPath } from '../../funnels/routing';

export default defineNuxtRouteMiddleware((to, from) => {
  const funnel = useFunnelContext();
  const resolved = funnelFromPath(to.path);

  if (funnel.value === resolved) {
    return;
  }

  const isClientNavigation = import.meta.client && from.matched.length > 0 && from.path !== to.path;

  if (isClientNavigation) {
    if (resolved === 'baseline') {
      return;
    }

    return navigateTo(to.fullPath, { external: true });
  }

  funnel.value = resolved;
});
